import { CONTACT_INFO, SOCIAL_MEDIA } from '../../values/constants';
import { generateWhatsAppUrl } from '../../utils/formatters';
import { getWhatsAppPath } from '../../utils/device';
import './Footer.css';

const Footer = () => {
  const whatsappUrl = generateWhatsAppUrl(
    CONTACT_INFO.whatsapp.number,
    CONTACT_INFO.whatsapp.defaultMessage,
    getWhatsAppPath()
  );

  return (
    <footer>
      {/* Contacto */}
      <section className="contacto" id="contacto">
        <div className="container">
          <div className="row">
            {/* Col 1 */}
            <div className="col-md-6 contacto-item">
              <h4>¡Contactanos!</h4>
              <p>
                ¡Escribinos o llamanos para recibir asesoramiento personalizado! <br />
                Trabajamos desde Argentina y Uruguay al mundo
              </p>
              <ul>
                <li>
                  <i className="fas fa-phone-alt"></i> {CONTACT_INFO.phones.join(' | ')}
                </li>
                <li>
                  <i className="fas fa-envelope"></i>{' '}
                  <a href={`mailto:${CONTACT_INFO.email}`}>{CONTACT_INFO.email}</a>
                </li>
              </ul>
            </div>

            {/* Col 2 */}
            <div className="col-md-6 contacto-item">
              <h4>Seguinos en redes</h4>
              <p>Encontranos en las redes para seguir todas nuestras novedades.</p>
              <ul>
                <li>
                  <i className="fab fa-facebook-square"></i>{' '}
                  <a href={SOCIAL_MEDIA.facebook} target="_blank" rel="noopener noreferrer">
                    Tambien Acepto
                  </a>
                </li>
                <li>
                  <i className="fab fa-instagram"></i>{' '}
                  <a href={SOCIAL_MEDIA.instagram} target="_blank" rel="noopener noreferrer">
                    tambienacepto
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Whatsapp flotante */}
        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="whatsapp-link whatsapp-fixed">
          <i className="fab fa-whatsapp"></i>
        </a>
      </section>

      <div className="footer">
        <p>Tambien Acepto &reg; - Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
